import React from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import { EnvironmentThemeProvider } from '@codex/themes';
import LoadResultAttachment from './LoadResultAttachment.jsx';

function initResultAttachment() {
  const eligibility = document.querySelector('[data-component="eligibility-block"]');

  if (eligibility) {
    ReactDOM.render(
      <Provider store={window.appState}>
        <EnvironmentThemeProvider>
          <>
            <LoadResultAttachment>
              <div />
            </LoadResultAttachment>
          </>
        </EnvironmentThemeProvider>
      </Provider>,
      eligibility
    );
  }
}

export default initResultAttachment;
